// Copyright © 2021 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default Object.freeze({
  ACTIVATION_MODE: 'activation-mode',
  APP_KEY: 'appkey',
  APP_SESSION_KEY: 'application-session-key',
  CLASSES: 'classes',
  DATA_RATE_OFFSET: 'data-rate-offset',
  DEV_EUI: 'deveui',
  DEVICE_ADDRESS: 'device-address',
  DEVICE_BRAND: 'device-brand',
  DEVICE_DESCRIPTION: 'device-description',
  DEVICE_FIRMWARE_VERSION: 'device-firmware-version',
  DEVICE_HARDWARE_VERSION: 'device-hardware-version',
  DEVICE_ID: 'device-id',
  DEVICE_MODEL: 'device-model',
  DEVICE_NAME: 'device-name',
  ENFORCE_DUTY_CYCLE: 'duty-cycle',
  FRAME_COUNTER_WIDTH: 'frame-counter-width',
  FREQUENCY_PLAN: 'frequency-plan',
  GATEWAY_ATTRIBUTES: 'gateway-attributes',
  GATEWAY_DESCRIPTION: 'gateway-description',
  GATEWAY_EUI: 'gateway-eui',
  GATEWAY_ID: 'gateway-id',
  GATEWAY_NAME: 'gateway-name',
  GATEWAY_STATUS: 'gateway-status',
  JOIN_EUI: 'joineui',
  JOIN_SERVER: 'join-server',
  LORAWAN_VERSION: 'lorawan-version',
  NETWORK_KEY: 'network-key',
  NETWORK_SESSION_KEY: 'network-session-key',
  REGIONAL_PARAMETERS: 'regional-parameters',
  REQUIRE_AUTHENTICATED_CONNECTION: 'require-authenticated-connection',
  RX2_DATA_RATE_INDEX: 'rx2-data-rate-index',
  RX2_FREQUENCY: 'rx2-frequency',
  SCHEDULE_ANYTIME_DELAY: 'schedule-anytime-delay',
  SCHEDULE_DOWNLINK_LATE: 'schedule-downlink-late',
  UPDATE_LOCATION_FROM_STATUS: 'update-location-from-status',
})
